// extracted by mini-css-extract-plugin
export default {"container":"SuccessOrInvalidPage_container__eZyxS","wrapper":"SuccessOrInvalidPage_wrapper__6eTGY","title":"SuccessOrInvalidPage_title__0xR+A"};